import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useDispatch } from "react-redux"
import handleRenderOption from "./handleRenderOption"
import { targetClienteAction, filtroClientesCotizadorAction } from "../../../ducks/cotizadorDuck"
import { useSelector } from "react-redux"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { InitialValueCliente } from "../InitialCliente"
const CBClientes = () => {
    const clientes = useSelector(store => store.cotizador.clientesAll)
    const dispatch = useDispatch()
    const getOptionHangle = (event, valor) => {
        if (valor) {
            dispatch(onLoadAnction({message: "Buscando..."}))
            dispatch(filtroClientesCotizadorAction({ idCliente: valor.IdCliente })).then(Response => {
                dispatch(offLoadAction())
                dispatch(targetClienteAction({ cliente: valor, vista: 1, editar: false }))
            })
        } else {
            dispatch(targetClienteAction({ cliente: InitialValueCliente, vista: 1, editar: false }))
            dispatch(filtroClientesCotizadorAction({ idCliente: 0 }))
        }
    }
    return (
        <div>
            <Autocomplete
                id={`id-auto-Clientes`}
                options={clientes.sort((a, b) => a.Nombre > b.Nombre)}
                getOptionLabel={(option) => {
                    let nombre = option?.Nombre 
                    return `${nombre} (${option.EMail})`
                }}
                style={{
                    width: "100%",
                    margin: "5px 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={clientes.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Clientes"
                        variant="outlined"
                        style={{ width: "100%" }}
                        name="clientes"
                    />
                )}
                renderOption={handleRenderOption}
            />
        </div>
    )
}
export default CBClientes